import { render, staticRenderFns } from "./GroupMembershipModal.vue?vue&type=template&id=54dc1010&scoped=true&"
import script from "./GroupMembershipModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupMembershipModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GroupMembershipModal.vue?vue&type=style&index=0&id=54dc1010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc1010",
  null
  
)

export default component.exports